module.exports = __webpack_public_path__ + "static/media/paso1compra.2fda5bd3.svg";